import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  rootComments: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  filterContainer: { display: "flex", gap: theme.spacing(2) },
  filter: {
    color: theme.palette.primary.main,
    lineHeight: "1.25rem",
    textTransform: "uppercase",
    cursor: "pointer",
    "&.active": {
      color: theme.palette.secondary.main,
      borderBottom: `1px solid ${theme.palette.secondary.main}`,
    },
  },
}));
